var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#3D42DF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9037 26.7906V29.1196L33.2616 32.5232L24.03 23.3738V16.7198L30.4674 13.9636V20.4116L36.9037 26.7906Z",
    fill: "#B3E5FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2616 32.5232L28.4512 36.9863L17.5803 26.2122V13.9636L24.0299 16.7198V23.3738L33.2616 32.5232Z",
    fill: "#4FC3F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4471 36.9863L25.0774 40.1322C24.486 40.6838 23.5636 40.6838 22.9722 40.1322L11.1429 29.1196V13.5222C11.1436 13.01 11.404 12.5326 11.836 12.2516C12.268 11.9706 12.8137 11.9237 13.288 12.1268L17.5803 13.9636V26.2122L28.4471 36.9863Z",
    fill: "#2196F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9037 13.5222V26.7906L30.4673 20.4116V13.9636L34.7586 12.1268C35.2329 11.9237 35.7786 11.9706 36.2106 12.2516C36.6426 12.5326 36.903 13.01 36.9037 13.5222Z",
    fill: "#2196F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.857a24295225a515a92658b2a798cae9.svg";
export { ForwardRef as ReactComponent };